import {
    type DeepPartial,
    type MoneyMapAccount,
    MoneyMapAccountType,
    type MoneyMapAccountWithAccountDetails,
    type MoneyMapBaseAccountDetails,
    MoneyMapCategory,
    type MoneyMapRuleWithAccountDetails,
    type MoneyMapWithRulesAndAccounts,
} from '@fruitful/types';
import { uniq } from 'lodash';

export const getNumAccountsForCategory = (
    category: MoneyMapCategory,
    incomeAccount?: DeepPartial<MoneyMapAccountWithAccountDetails>,
    rules?: Array<DeepPartial<MoneyMapRuleWithAccountDetails>>,
) => {
    if (category === MoneyMapCategory.INCOME) {
        return incomeAccount != null ? 1 : 0;
    }

    const moneyMapAccountIds = (rules ?? [])
        .map(
            (rule) =>
                rule.moneyMapAccountId ??
                (
                    rule.moneyMapAccount
                        ?.accountDetails as MoneyMapBaseAccountDetails
                )?.name,
        )
        .filter((id) => id != null);

    return uniq(moneyMapAccountIds).length;
};

export const isMoneyMapIncomeSplitEligible = (
    moneyMap: DeepPartial<MoneyMapWithRulesAndAccounts>,
    accounts: MoneyMapAccountWithAccountDetails[],
) => {
    const incomeAccount = accounts.find(
        (a) => a.id === moneyMap.incomeMoneyMapAccountId,
    );

    return isFruitfulAccount(incomeAccount);
};

export const isFruitfulAccount = (account?: DeepPartial<MoneyMapAccount>) => {
    return account?.type === MoneyMapAccountType.INTERNAL_BANKING;
};
